'use strict';

import 'moment'

export class CvConsts {
    static HolterCodes = [
        'Afib (I48.91)',
        'Aflutter (I48.92)',
        'Angina Pectoris (I20.8)',
        'AAE (I45.6)',
        'AV Block 1st Degree (I44.0)',
        'AVB 2nd Degree (I44.1)',
        'AV Block Unspecified (I44.3)',
        'Bifascicular Block (I45.2)',
        'Bradycardia (R00.1)',
        'Bundle Branch Block (I45.2)',
        'Cardiac Arrest (I46.9)',
        'Cerebral Infarction (I63.9)',
        'Chest Pain (R07.9)',
        'Chronic AF (I48.2)',
        'Conduction Disorder (AV) (I45.89)',
        'Conduction Disorder, Unspecified (I45.9)',
        'Dizziness / Vertigo (R42)',
        'Heart Valve (Z95.2)',
        'Left Bundle Branch Block (I44.7)',
        'Long QT Syndrome (I45.81)',
        'Lown-Ganong-Levine SYN (I45.6)',
        'Other Heart Block (I45.5)',
        'PACs (I49.1)',
        'Palpitations (R00.2)',
        'Paroxysmal AF (I48.0)',
        'PVCs (I49.3)',
        'RBBB and LAFB (I45.2)',
        'RBBB and LPFB (I45.2)',
        'RBBB (I45.10)',
        'Shortness of Breath (R06.02)',
        'Sinoatrial Node Dysfunction (I49.5)',
        'Slurred Speech (R47.81)',
        'SVT (I47.1)',
        'Syncope / Collapse (R55)',
        'Tachycardia (R00.0)',
        'TCIA, unspecified (G45.9)',
        'Trifascicular Block (I45.3)',
        'Ventricular Tachycardia (I47.2)',
        'Wolff-Parkinson-White syndrome (I45.6)',
        'Personal history of CVA (Z86.73)',
        'Personal history of TIA (Z86.73)',
    ];
    static OtherCodes = [
        'Afib (I48.91)',
        'Aflutter (I48.92)',
        'Angina Pectoris (I20.8)',
        'AAE (I45.6)',
        'AV Block 1st Degree (I44.0)',
        'AVB 2nd Degree (I44.1)',
        'AV Block Unspecified (I44.3)',
        'Bifascicular Block (I45.2)',
        'Bradycardia (R00.1)',
        'Bundle Branch Block (I45.2)',
        'Cardiac Arrest, Unspecified (I46.9)',
        'Cerebral Infarction (I63.9)',
        'Chest Pain (R07.9)',
        'Chronic AF (I48.2)',
        'Conduction Disorder (AV) (I45.89)',
        'Conduction Disorder (I45.9)',
        'Dizziness / Vertigo (R42)',
        'Heart Valve (Z95.2)',
        'Left Bundle Branch Block (I44.7)',
        'Long QT Syndrome (I45.81)',
        'Lown-Ganong-Levine SYN (I45.6)',
        'Other Heart Block (I45.5)',
        'PACs (I49.1)',
        'Palpitations (R00.2)',
        'Paroxysmal AF (I48.0)',
        'PVCs (I49.3)',
        'RBBB and LAFB (I45.2)',
        'RBBB and LPFB (I45.2)',
        'RBBB (I45.10)',
        'Shortness of Breath (R06.02)',
        'Sinoatrial Node Dysfunction (I49.5)',
        'Slurred Speech (R47.81)',
        'SVT (I47.1)',
        'Syncope / Collapse (R55)',
        'Tachycardia (R00.0)',
        'TCIA, unspecified (G45.9)',
        'Trifascicular Block (I45.3)',
        'Ventricular Tachycardia (I47.2)',
        'Wolff-Parkinson-White syndrome (I45.6)',
        'Personal history of CVA (Z86.73)',
        'Personal history of TIA (Z86.73)',
    ];
    static Modalities = [
        { text: "Holter", value: 'isHolter' },
        { text: "Extended holter", value: 'isExtended' },
        { text: "Event", value: 'isEvent' },
        { text: "MCT", value: 'isMct' },
        { text: "Holter + Event", value: 'isExtEvent' },
        { text: "Holter + MCT", value: 'isExtMct' }
    ];
    static USStates = [
        '-', 'Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District Of Columbia',
        'Federated States Of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
        'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
        'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon',
        'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands',
        'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
    ];

    static PrimaryTestTypes = [
        { text: 'Holter', value: 'holter' },
        { text: 'Extended Holter', value: 'extended' },
        { text: 'Event', value: 'wifi' },
        { text: 'MCT', value: 'mct'}
    ];
    static ExtendedTestTypes = [
        { text: 'Wireless Event', value: 'wifi' },
        { text: 'MCT', value: 'mct' }
    ];
}
